/* Team-Set-Karten: Modellauswahl tauscht Bild, Ziel-Link und die Ersparnis gegenueber Einzelkauf.
   geld() schreibt wie Shopify ("€890"), damit sich die Schreibweise beim Umschalten nicht aendert. */
(function () {
  function geld(c) {
    return '€' + (c / 100).toLocaleString('de-DE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function karteVerdrahten(karte) {
    var wahl = karte.querySelector('.hs-set-select');
    var bild = karte.querySelector('.hs-set-bild');
    var cta = karte.querySelector('.hs-set-cta');
    var vergleich = karte.querySelector('.hs-set-verglich');
    if (!wahl || !cta) return;

    var basis = cta.getAttribute('data-basis') || cta.getAttribute('href') || '';
    var anzahl = +karte.getAttribute('data-anzahl') || 0;
    var preis = +karte.getAttribute('data-preis') || 0;

    wahl.addEventListener('change', function () {
      var opt = wahl.options[wahl.selectedIndex];
      if (!opt) return;

      var variante = opt.getAttribute('data-variante');
      cta.setAttribute('href', variante ? basis + '?variant=' + variante : basis);

      var einzel = +opt.getAttribute('data-einzel') || 0;
      if (vergleich && einzel && anzahl) {
        var summe = einzel * anzahl, spar = summe - preis;
        if (spar > 0) {
          vergleich.hidden = false;
          vergleich.querySelector('[data-hs-einzeln]').textContent = geld(summe);
          vergleich.querySelector('[data-hs-spar]').textContent = geld(spar);
        } else {
          vergleich.hidden = true;
        }
      }

      var quelle = opt.getAttribute('data-bild');
      if (!bild || !quelle) return;
      var vorlader = new Image();
      vorlader.onload = function () { bild.src = quelle; bild.alt = opt.getAttribute('data-alt') || ''; bild.style.opacity = '1'; };
      vorlader.onerror = function () { bild.style.opacity = '1'; };
      bild.style.opacity = '0';
      vorlader.src = quelle;
    });
  }

  function start() {
    var karten = document.querySelectorAll('.hs-set');
    for (var i = 0; i < karten.length; i++) karteVerdrahten(karten[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
